import React, { useRef } from "react";
import Modal from "react-bootstrap/Modal";

import "./Feedback_modal.css";
import { Table } from "react-bootstrap";

const Feedback_modal = ({ show, onHide, setErr, feedback }) => {

  const formatMonth = (value) => {
    if (!value) return "";
    const [year, month] = value.split("-");
    const date = new Date(year, month - 1);
    return date.toLocaleString("en-US", { month: "short", year: "numeric" });
  };

  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Customer Feedback</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mt-3">
          {feedback ? (
            <div className="table-responsive">
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <th style={{ width: "40%" }}>Remark</th>
                    <td>{feedback?.feedback || "-"}</td>
                  </tr>

                  <tr>
                    <th>Rating</th>
                    <td>{feedback?.rating || 0} ⭐</td>
                  </tr>

                  <tr>
                    <th>Feedback Date</th>
                    <td>{formatDate(feedback?.createdAt) || "-"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center text-muted">No Feedback Available</div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Feedback_modal;
